import BaseService from '@/ecm/common/BaseService.js'
import Utils from '@/ecm/common/Utils.js'

class BasketService {
  baseUrl = 'basket';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  activate = (id) => BaseService.post({ url: `${this.baseUrl}/activate/${id}` });
  delete = (id) => BaseService.post({ url: `${this.baseUrl}/delete/${id}` });
  save = (user) => BaseService.post({ url: `${this.baseUrl}/save`, data: user });
  getAvailableContentTypes = (id, includeAllVersions) => BaseService.get({ url: `${this.baseUrl}/get-available-content-types/${id}/${includeAllVersions || false}` });
  getDocumentCount = (dashboardItemDTO) => BaseService.post({ url: `${this.baseUrl}/get-document-count`, data: dashboardItemDTO });
}

export default new BasketService()
